import overdueApplicationInboxReducer from "./overdueApplicationInboxReducer";
import supervisorReducer from "./supervisorReducer";
import overduePlaceReducer from "./overduePlaceReducer";
import overdueProductReducer from "./overdueProductReducer";

const overdueApplicationInboxReducers = {
    overdueApplicationInbox: overdueApplicationInboxReducer,
    supervisor: supervisorReducer,
    overduePlace: overduePlaceReducer,
    overdueProduct: overdueProductReducer
}

export default overdueApplicationInboxReducers;